<template>
  <div>
    <header
      class="max-w-[82.75rem] mx-auto max-md:!block max-md:text-center px-4 sm:px-6 lg:px-8"
    >
      <h2 class="font-bold max-md:mb-3">하나큐브</h2>

      <!-- 검색 -->
      <div class="mall_search_wr gap-3">
        <!-- <div class="flex-1 bg-white text-sm px-3 py-1 rounded">
          <p>
            <b>1</b> 하나바이블 5과정 2학기 <span class="ml-3 text-xs">▲</span>
          </p>
        </div> -->
        <label
          class="max-md:max-w-[33%] flex items-center border-r border-neutral-400 pr-2 gap-1"
        >
          <select
            :value="selectedCategoryId"
            @change="$emit('update:selectedCategoryId', $event.target.value)"
            class="w-full text-sm bg-transparent appearance-none"
          >
            <option value="">카테고리 전체</option>
            <option
              :value="category.categoryId"
              v-for="category in categoryList"
              :key="category.categoryId"
            >
              {{ category.categoryName }}
            </option>
            <!-- <option value="">하나바이블</option> -->
          </select>
          <svg
            width="9"
            height="5"
            viewBox="0 0 9 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.592761 0.000606174C0.670711 0.000246611 0.74795 0.0150999 0.819944 0.0442945C0.891939 0.0734892 0.95724 0.116437 1.01202 0.170619L4.54799 3.62496L8.08396 0.193801C8.19546 0.123176 8.32801 0.0911665 8.46035 0.102903C8.5927 0.11464 8.71718 0.169443 8.81384 0.258529C8.9105 0.347615 8.97375 0.465824 8.99345 0.594211C9.01314 0.722599 8.98815 0.853729 8.92246 0.966584L4.96724 4.8305C4.856 4.93904 4.70521 5 4.54799 5C4.39077 5 4.23997 4.93904 4.12873 4.8305L0.173507 0.966585C0.0624046 0.857912 -1.2917e-07 0.710601 -1.42597e-07 0.55701C-1.56025e-07 0.403419 0.0624045 0.256107 0.173507 0.147435C0.287996 0.0464373 0.438666 -0.0063289 0.592761 0.000606174Z"
              fill="black"
            />
          </svg>
        </label>

        <label class="w-full flex items-center gap-2">
          <input
            :value="searchQuery"
            @input="$emit('update:searchQuery', $event.target.value)"
            type="text"
            placeholder="검색어를 입력하세요."
            @keyup.enter="$emit('search', 1)"
          />

          <button type="button" @click="$emit('search', 1)">
            <font-awesome-icon icon="fa-solid fa-magnifying-glass" />
          </button>
        </label>
      </div>
    </header>

    <!-- 카테고리 영역  @mouseleave="hideSubCategories"-->
    <div
      ref="shopTopMenuRef"
      class="shop_top_menu relative"
      @mouseleave="$emit('hideSubCategories')"
    >
      <nav
        class="xl:min-w-[768px] p-0 overflow-auto max-w-[82.75rem] mx-auto md:gap-x-2 px-4 md:px-6 lg:px-8"
      >
        <router-link
          to="/mall"
          active-class="current"
          class="mr-2"
          @mouseover.stop="$emit('hideSubCategories')"
        >
          <span class="mainNav">
            <svg
              width="24"
              height="22"
              viewBox="0 0 24 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.459 0.66053C12.3259 0.556774 12.162 0.500427 11.9933 0.500427C11.8245 0.500427 11.6606 0.556774 11.5275 0.66053L0.75 9.06428L1.68225 10.2433L3 9.21578V18.5C3.00079 18.8976 3.15908 19.2787 3.44022 19.5598C3.72135 19.8409 4.10242 19.9992 4.5 20H19.5C19.8976 19.9992 20.2787 19.8409 20.5598 19.5598C20.8409 19.2787 20.9992 18.8976 21 18.5V9.22253L22.3177 10.25L23.25 9.07103L12.459 0.66053ZM13.5 18.5H10.5V12.5H13.5V18.5ZM15 18.5V12.5C15 12.1022 14.842 11.7207 14.5607 11.4394C14.2794 11.1581 13.8978 11 13.5 11H10.5C10.1022 11 9.72064 11.1581 9.43934 11.4394C9.15804 11.7207 9 12.1022 9 12.5V18.5H4.5V8.04653L12 2.20403L19.5 8.05403V18.5H15Z"
                fill="currentColor"
              />
            </svg>
            홈
          </span>
        </router-link>

        <div v-for="category in categoryList" :key="category.categoryId">
          <!-- 메인 카테고리 -->
          <router-link
            :to="'/mall/' + category.categoryId"
            :class="{ current: category.categoryId == route.params.category }"
            @mouseover.stop="$emit('getSubCategories', category.categoryId)"
          >
            <span class="mainNav">
              <svg
                v-if="category.categoryId == '170'"
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.61538 19.3015V14.8462H2.53846C2.13044 14.8462 1.73912 14.6841 1.45061 14.3955C1.16209 14.107 1 13.7157 1 13.3077V2.53846C1 2.13044 1.16209 1.73912 1.45061 1.45061C1.73912 1.16209 2.13044 1 2.53846 1H19.4615C19.8696 1 20.2609 1.16209 20.5494 1.45061C20.8379 1.73912 21 2.13044 21 2.53846V13.3077C21 13.7157 20.8379 14.107 20.5494 14.3955C20.2609 14.6841 19.8696 14.8462 19.4615 14.8462H11L6.27231 19.5738C6.21852 19.6278 6.14992 19.6645 6.07522 19.6794C6.00053 19.6943 5.92308 19.6867 5.85272 19.6575C5.78236 19.6284 5.72224 19.579 5.67999 19.5156C5.63773 19.4522 5.61525 19.3777 5.61538 19.3015Z"
                  stroke="currentColor"
                />
                <path
                  d="M5.61536 10.2308H16.3846M5.61536 5.61542H16.3846"
                  stroke="currentColor"
                  stroke-linecap="round"
                />
              </svg>

              <svg
                v-else-if="category.categoryId == '136'"
                width="24"
                height="22"
                viewBox="0 0 24 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.25 8C8.25 7.80109 8.32902 7.61032 8.46967 7.46967C8.61032 7.32902 8.80109 7.25 9 7.25H16C16.1989 7.25 16.3897 7.32902 16.5303 7.46967C16.671 7.61032 16.75 7.80109 16.75 8C16.75 8.19891 16.671 8.38968 16.5303 8.53033C16.3897 8.67098 16.1989 8.75 16 8.75H9C8.80109 8.75 8.61032 8.67098 8.46967 8.53033C8.32902 8.38968 8.25 8.19891 8.25 8ZM9 10.25C8.80109 10.25 8.61032 10.329 8.46967 10.4697C8.32902 10.6103 8.25 10.8011 8.25 11C8.25 11.1989 8.32902 11.3897 8.46967 11.5303C8.61032 11.671 8.80109 11.75 9 11.75H14C14.1989 11.75 14.3897 11.671 14.5303 11.5303C14.671 11.3897 14.75 11.1989 14.75 11C14.75 10.8011 14.671 10.6103 14.5303 10.4697C14.3897 10.329 14.1989 10.25 14 10.25H9Z"
                  fill="currentColor"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.5 3.25C7.24022 3.25 6.03204 3.75045 5.14124 4.64124C4.25045 5.53204 3.75 6.74022 3.75 8V18C3.75 18.9946 4.14509 19.9484 4.84835 20.6517C5.55161 21.3549 6.50544 21.75 7.5 21.75H18.5C18.9641 21.75 19.4092 21.5656 19.7374 21.2374C20.0656 20.9092 20.25 20.4641 20.25 20V5C20.25 4.53587 20.0656 4.09075 19.7374 3.76256C19.4092 3.43437 18.9641 3.25 18.5 3.25H8.5ZM18.75 14.25V5C18.75 4.9337 18.7237 4.87011 18.6768 4.82322C18.6299 4.77634 18.5663 4.75 18.5 4.75H8.5C7.63805 4.75 6.8114 5.09241 6.2019 5.7019C5.59241 6.3114 5.25 7.13805 5.25 8V15C5.89843 14.5119 6.68838 14.2485 7.5 14.25H18.75ZM18.75 15.75H7.5C6.90326 15.75 6.33097 15.9871 5.90901 16.409C5.48705 16.831 5.25 17.4033 5.25 18C5.25 18.5967 5.48705 19.169 5.90901 19.591C6.33097 20.0129 6.90326 20.25 7.5 20.25H18.5C18.5663 20.25 18.6299 20.2237 18.6768 20.1768C18.7237 20.1299 18.75 20.0663 18.75 20V15.75Z"
                  fill="currentColor"
                />
              </svg>

              <svg
                v-else-if="category.categoryId == '137'"
                width="18"
                height="22"
                viewBox="0 0 18 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.25 15.988V3.265L17.25 1.75V13.528M5.3955 6.778L17.589 5.038M5.25 15.9955C5.25 16.5922 5.01295 17.1645 4.59099 17.5865C4.16903 18.0084 3.59674 18.2455 3 18.2455C2.40326 18.2455 1.83097 18.0084 1.40901 17.5865C0.987053 17.1645 0.75 16.5922 0.75 15.9955C0.75 15.3988 0.987053 14.8265 1.40901 14.4045C1.83097 13.9826 2.40326 13.7455 3 13.7455C3.59674 13.7455 4.16903 13.9826 4.59099 14.4045C5.01295 14.8265 5.25 15.3988 5.25 15.9955ZM17.25 13.672C17.25 14.2687 17.0129 14.841 16.591 15.263C16.169 15.6849 15.5967 15.922 15 15.922C14.4033 15.922 13.831 15.6849 13.409 15.263C12.9871 14.841 12.75 14.2687 12.75 13.672C12.75 13.0753 12.9871 12.503 13.409 12.081C13.831 11.6591 14.4033 11.422 15 11.422C15.5967 11.422 16.169 11.6591 16.591 12.081C17.0129 12.503 17.25 13.0753 17.25 13.672Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
              </svg>

              <svg
                v-else-if="category.categoryId == '138'"
                width="21"
                height="22"
                viewBox="0 0 21 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11 0.9375L20.75 5V12.25H19.25V6.71353L18.5 7.08853V15.7863L17.9925 15.9597L17.75 15.25C17.9925 15.9597 17.9926 15.9597 17.9925 15.9597L17.9884 15.9611L17.978 15.9646L17.9388 15.9778C17.9048 15.9893 17.855 16.0059 17.7912 16.0269C17.6637 16.0688 17.4796 16.1285 17.2518 16.2C16.7964 16.3428 16.1639 16.5334 15.4554 16.7242C14.0646 17.0988 12.2905 17.5 11 17.5C9.70945 17.5 7.93531 17.0988 6.54455 16.7242C5.83608 16.5334 5.20356 16.3428 4.74819 16.2C4.52031 16.1285 4.33628 16.0688 4.20871 16.0269C4.14491 16.0059 4.09519 15.9893 4.06113 15.9778L4.02196 15.9646L4.01154 15.9611L4.00759 15.9598C4.0075 15.9597 4.00742 15.9597 4.24997 15.25L4.00759 15.9598L3.49997 15.7863V7.08853L0.198853 5.43797L11 0.9375ZM4.99997 7.83853V14.7064C5.06103 14.7259 5.12687 14.7467 5.19709 14.7687C5.63845 14.9072 6.25074 15.0916 6.93464 15.2758C8.32863 15.6512 9.92949 16 11 16C12.0705 16 13.6713 15.6512 15.0653 15.2758C15.7492 15.0916 16.3615 14.9072 16.8028 14.7687C16.8731 14.7467 16.9389 14.7259 17 14.7064V7.83853L11 10.8385L4.99997 7.83853ZM18.1989 5.56203L11 2.5625L3.80109 5.56203L11 9.16147L18.1989 5.56203Z"
                  fill="currentColor"
                />
              </svg>

              <svg
                v-else
                width="24"
                height="20"
                viewBox="0 0 24 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.459 0.66053C12.3259 0.556774 12.162 0.500427 11.9933 0.500427C11.8245 0.500427 11.6606 0.556774 11.5275 0.66053L0.75 9.06428L1.68225 10.2433L3 9.21578V18.5C3.00079 18.8976 3.15908 19.2787 3.44022 19.5598C3.72135 19.8409 4.10242 19.9992 4.5 20H19.5C19.8976 19.9992 20.2787 19.8409 20.5598 19.5598C20.8409 19.2787 20.9992 18.8976 21 18.5V9.22253L22.3177 10.25L23.25 9.07103L12.459 0.66053ZM13.5 18.5H10.5V12.5H13.5V18.5ZM15 18.5V12.5C15 12.1022 14.842 11.7207 14.5607 11.4394C14.2794 11.1581 13.8978 11 13.5 11H10.5C10.1022 11 9.72064 11.1581 9.43934 11.4394C9.15804 11.7207 9 12.1022 9 12.5V18.5H4.5V8.04653L12 2.20403L19.5 8.05403V18.5H15Z"
                  fill="currentColor"
                />
              </svg>
              {{ category.categoryName }}
            </span>
          </router-link>

          <!-- 서브 카테고리 -->
          <div
            v-if="categoryList2.length > 0"
            @mouseleave="$emit('hideSubCategories')"
            class="absolute z-10 w-full overflow-x-auto top-full left-0 bg-neutral-100 border-y border-neutral-300 p-3"
          >
            <div class="max-w-[82.75rem] mx-auto">
              <ul class="flex gap-x-2 w-max">
                <a
                  href="#"
                  @click.prevent="handleSubCategoryClick(subCategory)"
                  v-for="subCategory in categoryList2.filter(
                    (item) =>
                      ![
                        '이미지/영상설교',
                        '성경이야기',
                        '만들기 자료',
                      ].includes(item.categoryName)
                  )"
                  :key="subCategory.categoryId"
                  class="main-subMenu cursor-pointer"
                  :class="{
                    current: subCategory.categoryId == route.params.subcategory,
                  }"
                >
                  {{ subCategory.categoryName }}
                </a>
              </ul>
            </div>
          </div>
        </div>

        <router-link
          to="/mall/hana"
          active-class="current"
          @mouseover.stop="$emit('hideSubCategories')"
        >
          <span class="mainNav">
            <svg
              width="24"
              height="22"
              viewBox="0 0 24 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.7496 8.38281C11.9386 8.37968 12.1188 8.46232 12.2399 8.60742L15.5573 12.5879L19.7037 11.0615C19.9695 10.9636 20.2683 11.0564 20.4313 11.2881C20.5942 11.52 20.5803 11.8328 20.3981 12.0498L15.359 18.0498C15.2403 18.1912 15.0641 18.2725 14.8795 18.2725H8.87952C8.70489 18.2723 8.5378 18.1998 8.41956 18.0713L2.90002 12.0713C2.70709 11.8616 2.68081 11.5478 2.83557 11.3086C2.99035 11.0694 3.28698 10.9648 3.55725 11.0547L8.17737 12.5947L11.2662 8.62402L11.3131 8.57129C11.4275 8.45418 11.5841 8.3856 11.7496 8.38281ZM8.89319 13.7119C8.73056 13.9207 8.45391 14.0044 8.20276 13.9209L5.45862 13.0059L9.15393 17.0225H14.5885L17.9274 13.0479L15.5758 13.9141C15.3277 14.0054 15.0488 13.9306 14.8795 13.7275L11.776 10.0039L8.89319 13.7119Z"
                fill="currentColor"
              />
              <path
                d="M2.11035 9.72754C2.11018 9.4902 1.91707 9.29785 1.67969 9.29785C1.44245 9.29802 1.25017 9.4903 1.25 9.72754C1.25 9.96492 1.44235 10.158 1.67969 10.1582V11.4082L1.50781 11.3994C0.660849 11.3132 0 10.5973 0 9.72754C0.000168818 8.79995 0.752097 8.04802 1.67969 8.04785C2.60742 8.04785 3.36018 8.79984 3.36035 9.72754L3.35156 9.89941C3.26564 10.7467 2.54961 11.4082 1.67969 11.4082V10.1582C1.91717 10.1582 2.11035 9.96502 2.11035 9.72754Z"
                fill="currentColor"
              />
              <path
                d="M12.1903 5.40723C12.1901 5.16989 11.997 4.97754 11.7596 4.97754C11.5224 4.97771 11.3301 5.16999 11.33 5.40723C11.33 5.6446 11.5223 5.83772 11.7596 5.83789V7.08789L11.5878 7.0791C10.7408 6.99289 10.08 6.27694 10.08 5.40723C10.0801 4.47964 10.8321 3.72771 11.7596 3.72754C12.6874 3.72754 13.4401 4.47953 13.4403 5.40723L13.4315 5.5791C13.3456 6.42636 12.6296 7.08789 11.7596 7.08789V5.83789C11.9971 5.83789 12.1903 5.64471 12.1903 5.40723Z"
                fill="currentColor"
              />
              <path
                d="M22.7504 9.72754C22.7502 9.4902 22.5571 9.29785 22.3197 9.29785C22.0825 9.29802 21.8902 9.4903 21.89 9.72754C21.89 9.96492 22.0824 10.158 22.3197 10.1582V11.4082L22.1478 11.3994C21.3009 11.3132 20.64 10.5973 20.64 9.72754C20.6402 8.79995 21.3921 8.04802 22.3197 8.04785C23.2474 8.04785 24.0002 8.79984 24.0004 9.72754L23.9916 9.89941C23.9057 10.7467 23.1896 11.4082 22.3197 11.4082V10.1582C22.5572 10.1582 22.7504 9.96502 22.7504 9.72754Z"
                fill="currentColor"
              />
            </svg>

            하나바이블
          </span>
        </router-link>
      </nav>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, defineExpose } from "vue";
import { useRoute, useRouter } from "vue-router";

const route = useRoute();
const router = useRouter();
const shopTopMenuRef = ref(null);

// Props 정의
const props = defineProps({
  categoryList: {
    type: Array,
    default: () => [],
  },
  categoryList2: {
    type: Array,
    default: () => [],
  },
  activeCategory: {
    type: String,
    default: null,
  },
  selectedCategoryId: {
    type: String,
    default: "",
  },
  searchQuery: {
    type: String,
    default: "",
  },
});

const handleSubCategoryClick = (subCategory) => {
  const restrictedList = ["콘티/송리스트", "음원", "악보"];

  if (restrictedList.includes(subCategory.categoryName)) {
    alert("준비중 입니다");
    return;
  }

  router.push(`/mall/${props.activeCategory}/${subCategory.categoryId}`);
};

// Emits 정의
defineEmits([
  "update:selectedCategoryId",
  "update:searchQuery",
  "search",
  "getSubCategories",
  "hideSubCategories",
]);

// shopTopMenuRef를 부모 컴포넌트에서 접근할 수 있도록 expose
defineExpose({
  shopTopMenuRef,
});
</script>
